<p-multiSelect [options]="list" [(ngModel)]="selectedList" [defaultLabel]="placeHolderLanguage" optionLabel="name"
[filter]="true" scrollHeight="280px" (onChange)="feedback()" [style]="{'width': '100%'}" appendTo="body"></p-multiSelect>


